export const DOCUMENT_ID_LENGTH_MAX = 512;
export const DOCUMENT_TYPE_LENGTH_MAX = 128;
export const QUERY_LIMIT_DEFAULT = 1_000;
export const QUERY_LIMIT_MAX = 100_000;
export const PORTABLE_BLOB_COUNT_MAX = 10_000;
export const PORTABLE_BLOB_BYTES_MAX = 32 * 1024 * 1024;
export const PORTABLE_TOTAL_BLOB_BYTES_MAX = 128 * 1024 * 1024;
export const JSON_DEPTH_MAX = 64;
export const JSON_NODE_COUNT_MAX = 1_000_000;
export const LARGE_MEDIA_WARNING_BYTES = 10 * 1024 * 1024;
//# sourceMappingURL=constants.js.map